module.exports = __webpack_public_path__ + "img/Neopark_TC.1b4cceb6.jpg";